import * as ACTION_TYPES from './Types'

const initialState = {
    message: "",
    error: null,
    colorList: { filter_record: 0, total_record: 0 },
    color: {},
    page: 1,
    limit: 10,
}

export const ColorReducer = (state = initialState, action) => {
    switch (action.type) {
        case ACTION_TYPES.FETCH_COLORLIST_SUCCESS:
            return {
                ...state,
                colorList: action.payload,
                message: action.payload.message,
                error: null
            }
        case ACTION_TYPES.COLOR_PAGE_CHANGE:
            return {
                ...state,
                page: action.payload
            }
        case ACTION_TYPES.COLOR_LIMIT_CHANGE:
            return {
                ...state,
                limit: action.payload
            }
        case ACTION_TYPES.DEL_COLOR_SUCCESS:
        case ACTION_TYPES.ADD_COLOR_SUCCESS:
        case ACTION_TYPES.GET_COLOR_SUCCESS:
            return {
                ...state,
                color: action.payload.data,
                message: action.payload.message,
                isEdited: false,
                error: null
            }
        case ACTION_TYPES.FETCH_COLORLIST_ERROR:
        case ACTION_TYPES.DEL_COLOR_ERROR:
        case ACTION_TYPES.ADD_COLOR_ERROR:
            return {
                ...state,
                message: action.payload.data.message,
                error: action.payload.data.message,
                isEdited: false
            }
        case ACTION_TYPES.GET_COLOR_ERROR:
            return {
                ...state,
                color: null,
                message: action.payload.data.message,
                error: action.payload.data.message
            }
        case ACTION_TYPES.EDIT_COLOR_ERROR:
            return {
                ...state,
                message: action.payload.data.message,
                error: action.payload.data.message,
                isEdited: false
            }
        case ACTION_TYPES.EDIT_COLOR_SUCCESS:
            return {
                ...state,
                color: action.payload.data,
                message: action.payload.message,
                isEdited: true,
                error: null
            }
        default:
            return state
    }
}

